import { render } from "./ManavisCollege.vue?vue&type=template&id=b14c5d86&scoped=true"
import script from "./ManavisCollege.vue?vue&type=script&lang=js"
export * from "./ManavisCollege.vue?vue&type=script&lang=js"

import "../../assets/css/custom.css?vue&type=style&index=0&id=b14c5d86&scoped=true&lang=css"
import "../../assets/css/module.css?vue&type=style&index=1&id=b14c5d86&scoped=true&lang=css"
import "../../assets/css/module_sp.css?vue&type=style&index=2&id=b14c5d86&scoped=true&lang=css"
import "../../assets/css/top.css?vue&type=style&index=3&id=b14c5d86&scoped=true&lang=css"
import "./ManavisCollege.vue?vue&type=style&index=4&id=b14c5d86&scoped=true&lang=css"

import exportComponent from "D:\\Nomura\\PROJECT\\010.Src_By_SYSLAB\\007.MCSC_Web\\Git_main\\FrontEnd\\site\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b14c5d86"]])

export default __exports__